import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AccountContact {
  id: string;
  full_name: string | null;
  email: string | null;
  job_title: string | null;
  linkedin_url: string | null;
  seniority_level: string | null;
  department: string | null;
}

export function useAccountContacts(accountId: string | null | undefined) {
  return useQuery({
    queryKey: ['account-contacts', accountId],
    queryFn: async (): Promise<AccountContact[]> => {
      if (!accountId) return [];

      const { data, error } = await supabase
        .from('contacts')
        .select('id, full_name, email, job_title, linkedin_url, seniority_level, department')
        .eq('company_id', accountId)
        .not('full_name', 'is', null)
        .neq('full_name', '')
        .order('full_name');

      if (error) throw error;
      return (data || []) as AccountContact[];
    },
    enabled: !!accountId,
  });
}
